const AppLoader = () => {
    return (
        <div className="bg-white flex items-center justify-center fixed top-0 left-0 right-0 bottom-0 w-full h-full z-50">
            <div className="w-14 h-14 rounded-full animate-spin border-y-8 border-solid border-primary border-t-transparent"></div>
        </div>
    );
};

export default AppLoader;
